import { IconProps } from '@rsuite/icons/lib/Icon'
import { FC } from 'react'

import { VERY_LIGHT_GRAY } from '../../utils/constants'

export type StarProgress = '0%' | '25%' | '50%' | '75%' | '100%'

interface StarIconProgressProps extends IconProps {
  progress: StarProgress
}

const StarIconProgress: FC<StarIconProgressProps> = ({ className, progress }) => (
  <svg
    width="17"
    height="17"
    viewBox="-0 -0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <defs>
      <linearGradient
        id={`grad-${progress}`}
        x1="0%"
        y1="0%"
        x2="100%"
        y2="0%"
      >
        <stop
          offset={progress}
          stopColor="#FFD202"
        />
        <stop
          offset={progress}
          stopColor={VERY_LIGHT_GRAY}
        />
      </linearGradient>
    </defs>
    <g>
      <path
        d="M5.04894 0.823412C5.3483 -0.0978985 6.6517 -0.0978978 6.95106 0.823413L7.68386 3.07874C7.81773 3.49076 8.20169 3.76972 8.63491 3.76972L11.0063 3.76972C11.975 3.76972 12.3778 5.00933 11.5941 5.57873L9.67559 6.9726C9.3251 7.22724 9.17845 7.67861 9.31232 8.09063L10.0451 10.346C10.3445 11.2673 9.28999 12.0334 8.50628 11.464L6.58778 10.0701C6.2373 9.81548 5.7627 9.81548 5.41221 10.0701L3.49372 11.464C2.71001 12.0334 1.65553 11.2673 1.95488 10.346L2.68768 8.09063C2.82155 7.67861 2.6749 7.22724 2.32441 6.9726L0.405917 5.57873C-0.377797 5.00933 0.0249789 3.76972 0.993702 3.76972L3.36509 3.76972C3.79832 3.76972 4.18227 3.49076 4.31614 3.07873L5.04894 0.823412Z"
        fill={`url(#grad-${progress})`}
      />
    </g>
  </svg>
)

export default StarIconProgress

export const StarIconFullyColored: FC<IconProps> = ({ className }) => (
  <StarIconProgress
    className={className}
    progress="100%"
  />
)
